<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "@/components/PhotoBox.vue";
import { calculateYearsPerPosition, formatTotalYearsSimple } from "@/utils/proposalValidation.js";

export default {
    name: "ResumeTemp7",
    components: {
        SpellCheckedText,
        PhotoBox
    },
	data() {
       return {
         memberPages: []
        };
   },
    props: {
        resume: { type: Object, required: true },
        pageGap: { type: Boolean, default: true },
        startPage: { type: Number, default: 1 },
    },
    computed: {},
    methods: {
        calculateYearsPerPosition,
        formatTotalYearsSimple,
		async m_getResumeData(teamMemberId) {
		    let resumeData=await this.$store.dispatch('getResumeData', teamMemberId);
		    return resumeData;
		},
      async m_memberPages() {
            const pages = [];
            const projectsPerPage = this.resume.projectsPerPage || 6; // Standard 6 for landscape 3x2 grid

            
			for (const member of this.resume.members) {
                const memberProjects = member.projects || [];

                // Safe parse of resumeData string
				let resumeData=await this.m_getResumeData(member.teamMemberId);
                //let parsedResumeData = member.resumeData;
				let parsedResumeData = resumeData;
                if (typeof parsedResumeData === 'string') {
                    try {
                        parsedResumeData = JSON.parse(parsedResumeData);
                    } catch (e) {
                        parsedResumeData = null;
                    }
                }
                const memberWithParsedData = member; // Keep original reference

                if (memberProjects.length === 0) {
                    pages.push({ member: memberWithParsedData, parsedResumeData, projects: [], isFirstPage: true });
                } else {
                    for (let i = 0; i < memberProjects.length; i += projectsPerPage) {
                        pages.push({
                            member: memberWithParsedData,
                            parsedResumeData,
                            projects: memberProjects.slice(i, i + projectsPerPage),
                            isFirstPage: i === 0,
                        });
                    }
                }
            }

            this.memberPages=pages;
        }		
    },
watch: {
  'resume.members': {
    deep: true,
    immediate: true,
    handler() {
      this.m_memberPages();
    }
  },
  'resume.members.length'(val) {
    if (val > 0) this.m_memberPages();
  },
  '$store.state.members.data': {
    deep: true,
    handler() {
      this.m_memberPages();
    }
  }
}	
};
</script>

<template>
  <div class="main-container" :style="{
    gap: pageGap ? '20px' : '0px',
    '--header-color': resume.style.colorScheme.header,
    '--body-color': resume.style.colorScheme.body,
    '--footer-color': resume.style.colorScheme.footer,
    '--heading-color': resume.style.heading.color,
    '--heading-size': (resume.style.heading.size) + 'px',
    '--heading-weight-bold': resume.style.heading.bold ? '900' : 'bold',
    '--heading-weight': resume.style.heading.bold ? 'bold' : 'normal',
    '--heading-style': resume.style.heading.italic ? 'italic' : 'normal',
    '--heading-decoration': resume.style.heading.underline ? 'underline' : 'none',
    '--heading-font': resume.style.heading.font,
    '--label-color': resume.style.label.color,
    '--label-size': (resume.style.label.size) + 'px',
    '--label-weight': resume.style.label.bold ? 'bold' : 'normal',
    '--label-weight-bold': resume.style.label.bold ? '900' : 'bold',
    '--label-style': resume.style.label.italic ? 'italic' : 'normal',
    '--label-decoration': resume.style.label.underline ? 'underline' : 'none',
    '--label-font': resume.style.label.font,
    '--text-color': resume.style.text.color,
    '--text-size': (resume.style.text.size) + 'px',
    '--text-weight': resume.style.text.bold ? 'bold' : 'normal',
    '--text-style': resume.style.text.italic ? 'italic' : 'normal',
    '--text-decoration': resume.style.text.underline ? 'underline' : 'none',
    '--text-font': resume.style.text.font,
    '--project-columns': resume.projectsPerPage / 2,
  }">
    <div v-for="(page, pageIndex) in memberPages" :key="pageIndex" class="profile-container page-unit landscape-split">

      <!-- SIDEBAR (Left) -->
      <div class="sidebar">
        <!-- Picture -->
        <div class="profile-image-container photobox" v-if="page.isFirstPage">
          <PhotoBox class="member-photo-box" type="profile" :project="page.member" bgColor="#e0e0e0" />
        </div>

        <div class="personal-info" v-if="page.isFirstPage">
          <h1 class="member-name">
            <SpellCheckedText :value="page.member.teamMemberName || 'N/A'"
              @input="page.member.teamMemberName = $event" />
          </h1>
          <h2 class="member-role">
            <SpellCheckedText :value="page.member.role || 'N/A'" @input="page.member.role = $event" />
          </h2>
        </div>

        <div class="sidebar-details" v-if="page.isFirstPage">

          <!-- Cell 1: YEARS OF EXPERIENCE -->
          <div class="sidebar-section">
            <h4 class="section-label">YEARS OF EXPERIENCE</h4>
            <div v-if="page.parsedResumeData && page.parsedResumeData.positions && page.parsedResumeData.positions.length > 0">
              <p class="section-value mb-1">
                <SpellCheckedText :value="page.parsedResumeData.positions[0].company || ''"
                  @input="page.parsedResumeData.positions[0].company = $event" />
                <span v-if="page.parsedResumeData.positions[0].company">: </span>
                <SpellCheckedText
                  :value="page.parsedResumeData.positions[0].calculatedYears !== undefined ? page.parsedResumeData.positions[0].calculatedYears : calculateYearsPerPosition(page.parsedResumeData.positions[0])"
                  @input="page.parsedResumeData.positions[0].calculatedYears = $event" />
              </p>

              <p class="section-value">
                Industry: {{ formatTotalYearsSimple(page.parsedResumeData.positions) }}
              </p>
            </div>
          </div>

          <!-- Cell 2: REGISTRATIONS/ CERTIFICATIONS -->
          <div class="sidebar-section">
            <h4 class="section-label mb-1">REGISTRATIONS/ CERTIFICATIONS</h4>
            <div
              v-if="(page.parsedResumeData && page.parsedResumeData.certifications && page.parsedResumeData.certifications.length > 0) || (page.member.certifications && page.member.certifications.length > 0)">
              <div class="certifications-list">
                <div
                  v-for="(cert, cIndex) in ((page.parsedResumeData && page.parsedResumeData.certifications) || page.member.certifications || [])"
                  :key="'cert-' + cIndex" class="cert-item section-value mb-2">
                  <SpellCheckedText :value="cert.name || ''" @input="cert.name = $event" />
                  <span v-if="cert.issuer">-
                    <SpellCheckedText :value="cert.issuer" @input="cert.issuer = $event" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Cell 3: EDUCATION -->
          <div class="sidebar-section">
            <h4 class="section-label">EDUCATION</h4>
            <div v-if="page.parsedResumeData && page.parsedResumeData.education && page.parsedResumeData.education.length > 0">
              <p v-for="(edu, i) in ((page.parsedResumeData && page.parsedResumeData.education) || [])" :key="'edu-' + i"
                class="section-value mb-1">
                <SpellCheckedText :value="edu.degree || ''" @input="edu.degree = $event" />
                <span v-if="edu.degree && (edu.field || edu.school)">, </span>
                <SpellCheckedText :value="edu.field || ''" @input="edu.field = $event" />
                <br v-if="edu.school" />
                <SpellCheckedText :value="edu.school || ''" @input="edu.school = $event" />
                <span v-if="edu.year"> ({{ edu.year }})</span>
              </p>
            </div>
          </div>

          <!-- Cell 4: CITY OF RESIDENCE -->
          <div class="sidebar-section">
            <h4 class="section-label">CITY OF RESIDENCE</h4>
            <div
              v-if="page.member.cityOfResidence && page.member.cityOfResidence !== 'N/A' && page.member.cityOfResidence !== ''">
              <p class="section-value">
                <SpellCheckedText :value="page.member.city" @input="page.member.city = $event" />
                <span v-if="page.member.city && page.member.stateProvince">, </span>
                <SpellCheckedText :value="page.member.stateProvince" @input="page.member.stateProvince = $event" />
              </p>
            </div>
          </div>
        </div>

        <div class="role-desc-section" v-if="page.isFirstPage">
          <h4 class="section-label">ROLE DESCRIPTION</h4>
          <p class="role-desc-text section-value">
            <SpellCheckedText :value="page.member.whyTeamMember || page.member.roleDescription || 'N/A'"
              @input="page.member.whyTeamMember = $event" />
          </p>
        </div>

        <div class="bottom-project-name mt-auto">
          <SpellCheckedText :value="resume.opprName || 'BCIT Academic Center Project'"
            @input="resume.opprName = $event" />
        </div>
      </div>

      <!-- MAIN CONTENT (Right) -->
      <div class="main-body">
        <div class="right-header">
          <p class="m-0">
            <SpellCheckedText :value="resume.title || ''" @input="resume.title = $event" />
          </p>
        </div>

        <div class="projects-section">
          <h3 class="relevant-heading">RELEVANT PROJECT EXPERIENCE</h3>
          <div class="projects-grid">
            <div v-for="(project, pIndex) in page.projects" :key="pIndex" class="project-item">
              <div class="project-img">
                <PhotoBox v-if="project" class="photobox" :project="project" bgColor="#e0e0e0" />
                <div v-else class="placeholder-img" />
              </div>
              <div class="project-header">
                <div>
                  <h4 class="project-title">
                    <SpellCheckedText :value="project.projectName || ''" @input="project.projectName = $event" />
                  </h4>
                  <p class="project-location" v-if="project.city || project.stateProvince">
                    <SpellCheckedText :value="project.city || ''" @input="project.city = $event" />
                    <span>{{ project.city ? ', ' : '' }}</span>
                    <SpellCheckedText :value="project.stateProvince || ''" @input="project.stateProvince = $event" />
                  </p>
                </div>

                <p class="project-desc">
                  <SpellCheckedText :value="project.projectDetails || ''" @input="project.projectDetails = $event" />
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="footer-bottom">
          <p class="footer-title">
            <SpellCheckedText :value="resume.submittedBy || ''" @input="resume.submittedBy = $event" />
          </p>
          <p class="footer-divider">|</p>
          <p class="footer-page">{{ startPage + pageIndex }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.main-container {
  display: flex;
  flex-direction: column;
  width: 296.83mm;
  min-height: 211mm;
  position: relative;
  box-sizing: border-box;

  &:hover {
    .photobox :deep(.photo-overlay) {
      opacity: 1;
    }

    .photobox :deep(img) {
      opacity: 0.9;
    }
  }

  .profile-container {
    display: flex;
    flex-direction: row;
    background: white;
    height: 211mm;
    overflow: hidden;
    position: relative;
    padding: 0;

    .sidebar {
      position: relative;
      width: 30%;
      background: var(--header-color);
      display: flex;
      flex-direction: column;
      padding: 30px 30px 30px 40px;
      color: white;

      .profile-image-container {
        position: relative;
        width: 130px;
        height: 130px;
        border-radius: 50%;
        overflow: hidden;
        margin-bottom: 10px;
        background: #e0e0e0;

        .member-photo-box {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .pictureBox {
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          width: 100%;
          height: 100%;

          .head {
            background: white;
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }

          .body {
            background: white;
            width: 80px;
            height: 50px;
            border-top-left-radius: 50%;
            border-top-right-radius: 50%;
          }
        }
      }

      .personal-info {
        margin-bottom: 20px;

        .member-name {
          font-size: var(--heading-size);
          font-weight: var(--heading-weight-bold);
          color: var(--heading-color);
          font-style: var(--heading-style);
          text-decoration: var(--heading-decoration);
          font-family: var(--heading-font);
          margin-bottom: 4px;
        }

        .member-role {
          font-size: var(--heading-size);
          font-weight: var(--heading-weight);
          font-family: var(--heading-font);
          font-style: var(--heading-style);
          text-decoration: var(--heading-decoration);
          color: var(--heading-color);
          margin-bottom: 0px;
        }
      }

      .sidebar-details {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 5px;
        margin-bottom: 20px;
      }

      .sidebar-section {
        min-height: 60px;
      }

      .section-label {
        font-size: var(--label-size);
        font-weight: var(--label-weight);
        font-family: var(--label-font);
        font-style: var(--label-style);
        text-decoration: var(--label-decoration);
        color: var(--body-color);
        margin-bottom: 6px;
        text-transform: uppercase;
      }

      .section-value {
        font-size: var(--text-size);
        font-weight: var(--text-weight);
        font-family: var(--text-font);
        font-style: var(--text-style);
        text-decoration: var(--text-decoration);
        color: var(--footer-color);
        line-height: 1.3;
        margin-bottom: 0px;
      }

      .role-desc-section {
        .role-desc-text {
          line-height: 1.3;
          margin-bottom: 0px;
        }
      }

      .bottom-project-name {
        position: absolute;
        bottom: 30px;
        left: 30px;
        font-size: 12px;
        font-weight: bold;
        color: white;
        letter-spacing: 0.5px;
      }
    }


    .main-body {
      width: 70%;
      display: flex;
      flex-direction: column;
      background: white;
      padding: 20px 30px;

      .right-header {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        font-size: 16px;
        font-weight: 700;
        color: black;
        margin-bottom: 15px;
      }

      .projects-section {
        flex: 1;

        .relevant-heading {
          font-size: 18px;
          font-weight: bold;
          color: var(--header-color);
          text-transform: uppercase;
          margin-bottom: 15px;
        }

        .projects-grid {
          display: grid;
          grid-template-columns: repeat(var(--project-columns), 1fr);
          grid-template-rows: 315px 315px;
          gap: 15px;
          height: 100%;
          overflow: hidden;

          .project-item {
            .project-img {
              height: 120px;
              width: 100%;
              border-radius: 6px;
              overflow: hidden;
              margin-bottom: 10px;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }

              .placeholder-img {
                width: 100%;
                height: 100%;
                background: "#e0e0e0";
              }
            }

            .project-header {
              display: flex;
              flex-direction: column;
              gap: 15px;
              height: 185px;
              overflow: hidden;

              .project-title {
                font-size: var(--label-size);
                font-weight: var(--label-weight-bold);
                font-family: var(--label-font);
                font-style: var(--label-style);
                text-decoration: var(--label-decoration);
                color: var(--label-color);
                margin: 0;
              }

              .project-location {
                font-size: var(--label-size);
                font-weight: var(--label-weight);
                font-family: var(--label-font);
                font-style: var(--label-style);
                text-decoration: var(--label-decoration);
                color: var(--label-color);
                margin: 0;
              }

              .project-desc {
                font-size: var(--text-size);
                font-weight: var(--text-weight);
                font-family: var(--text-font);
                font-style: var(--text-style);
                text-decoration: var(--text-decoration);
                color: var(--text-color);
                line-height: 1.25;
                margin-bottom: 0;
              }
            }

          }
        }
      }

      .footer-bottom {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-top: 10px;
        text-align: right;
        font-family: Helvetica;

        .footer-title {
          font-size: 12px;
          color: black;
          font-weight: bold;
          margin: 0;
        }

        .footer-divider {
          font-size: 12px;
          color: black;
          font-weight: bold;
          margin: 0;
          padding: 0px 10px;
        }

        .footer-page {
          font-size: 16px;
          color: var(--header-color);
          font-weight: 800;
          margin: 0;
        }
      }
    }
  }
}
</style>
